<template>
  <div class="page">
    <el-button type="primary" @click="exportData" :loading="exporting" :disabled="exporting" >导出数据</el-button>
    <div class="box-order-data-overview">
      <el-row :gutter="15" class="wrapper">
        <el-col :lg="12">
          <el-row :gutter="15" class="wrapper">
            <el-col :lg="12">
              <div class="card section">
                <p class="page-title">订单</p>
                <div class="content">
                  <div class="item">
                    <i class="el-icon-tickets"></i>
                    <c-link-button :to="{ name: 'orders.index', query: { shop_status_eq: 'wait_seller_send_goods' } }">
                      <p class="name">待发货订单数</p>
                      <p class="value">{{ $get(data, 'todo_items.wait_send_goods_count.order') }}</p>
                    </c-link-button>
                  </div>
                  <div class="item">
                    <i class="el-icon-s-claim"></i>
                    <c-link-button :to="{ name: 'orders.index', query: { shop_status_not_eq: 'trade_closed', color_label_not_null: true } }">
                      <p class="name">标色订单数</p>
                      <p class="value">{{ $get(data, 'todo_items.color_lable_count.order') }}</p>
                    </c-link-button>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :lg="6">
              <div class="card section">
                <p class="page-title">售后</p>
                <div class="content">
                  <div class="item">
                    <i class="el-icon-phone-outline"></i>
                    <c-link-button :to="{ name: 'after_sales.index', query: { shop_status_in: ['wait_seller_agree', 'wait_seller_confirm_goods'] } }">
                      <p class="name">待处理售后数</p>
                      <p class="value">{{ $get(data, 'todo_items.pending_after_sale_count') }}</p>
                    </c-link-button>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :lg="6">
              <div class="card section">
                <p class="page-title">用户建议</p>
                <div class="content">
                  <div class="item">
                    <i class="el-icon-edit-outline"></i>
                    <c-link-button :to="{ name: 'user_suggestions.index', query: { status_eq: 'pending' } }">
                      <p class="name">待审核用户建议数</p>
                      <p class="value">{{ $get(data, 'todo_items.pending_user_suggestion_count') }}</p>
                    </c-link-button>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row ::gutter="15">
            <div class="item section">
              <h5 class="page-title">订单/用户数据概览</h5>
              <el-table :data="orderDataPreview" :show-header="false">
                <el-table-column
                  prop="name"
                  label="name"
                  class-name="field-column"
                />
                <el-table-column
                  prop="value"
                  label="value"
                  :width="120"
                  class-name="price-column"
                />
              </el-table>
            </div>
          </el-row>
        </el-col>
        <el-col :lg="12">
          <div class="item section">
            <h5 class="page-title">产品销售 TOP10</h5>
            <c-source-table
              :columns="top10ColorProductsColumns"
              :table="{ data: data.top10_color_products, 'show-header': false }"
            />
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="section box-charts">
      <h5 class="page-title">订单趋势</h5>
      <div class="content">
        <c-echarts :options="orderNumTrendOptions" />
        <c-echarts :options="orderAmountTrendOptions" />
      </div>
    </div>

    <div class="section box-stat">
      <h5 class="page-title">订单来源统计</h5>
      <c-echarts :options="orderSourcesPieOptions" />
    </div>

  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import _ from 'lodash';
import moment from 'moment';

@Component
export default class Home extends Vue {

  data = {};
  exporting = false;

  get orderDataPreview() {
    const { order_sum_pay_amnount = 0, today_order_count, today_order_pay_amount = 0, recent_7_day_order_count, recent_7_day_order_pay_amount = 0, user_count, today_new_user_count } = this.data.order_data_overview || {};
    return [
      {
        name: '订单总金额',
        value: `¥${order_sum_pay_amnount}`
      },
      {
        name: '今日新增订单数',
        value: today_order_count
      },
      {
        name: '今日订单金额',
        value: `¥${today_order_pay_amount}`
      },
      {
        name: '近7日新增订单数',
        value: recent_7_day_order_count
      },
      {
        name: '近7日订单金额',
        value: recent_7_day_order_pay_amount
      },
      {
        name: '用户总数',
        value: user_count
      },
      {
        name: '今日新增用户数',
        value: today_new_user_count
      }
    ]
  }

  get top10ColorProductsColumns() {
    return [
      {
        prop: 'name',
        label: '产品名',
        'class-name': 'table-field-column',
        renderCell: (h, { row }) => {
          return <c-link-button to={{ name: 'products.show', params: { id: row.product_id } }}>{ row.name }</c-link-button>
        }
      },
      {
        prop: 'real_sale_count',
        label: '销量',
        width: 120,
        'class-name': 'table-value-column',
        renderCell: (h, { row }) => {
          return <c-link-button to={{ name: 'products.show', params: { id: row.product_id } }}>{ row.real_sale_count }</c-link-button>
        }
      }
    ]
  }

  get orderNumTrendOptions() {
    const { order_num_trend = {}, paid_order_num_trend = {} } = _.get(this.data, 'recent_30_order_trend') || {};
    return this.createChartOptions([order_num_trend, paid_order_num_trend], ['订单数', '支付订单数']);
  }

  get orderAmountTrendOptions() {
    const { order_paid_amount_trend = {}, order_actual_amount_trend = {} } = _.get(this.data, 'recent_30_order_trend') || {};
    return this.createChartOptions([order_paid_amount_trend, order_actual_amount_trend], ['销售总额', '支付总额']);
  }

  get orderSourcesPieOptions() {
    const order_sources = _.get(this.data, 'order_sources') || {};
    return {
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
      },
      legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 10,
          top: 20,
          bottom: 20,
          data: Object.keys(order_sources)
      },
      series: [
        {
          name: '订单来源',
          type: 'pie',
          radius: '55%',
          center: ['40%', '50%'],
          data: _.map(order_sources, (value, name) => ({ name, value })).sort((a, b) => b.value - a.value),
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    }
  }

  async exportData() {
    this.exporting = true;
    try {
      await this.$download({
        url: '/statistics/export_dashboard',
        name: _.get(this.$route, 'meta.title', 'resource') + '.xlsx'
      });
    } finally {
      this.exporting = false;
    }
  }

  async mounted() {
    this.data = await this.$request.get('/statistics/dashboard');
  }

  createChartOptions(resouceArr, legendArr) {
    const xAxisData = [...new Set(Object.keys(resouceArr[0]).concat(Object.keys(resouceArr[1])))].sort((a, b) => moment(a).diff(moment(b)));
    const getSeriesData = (data) => xAxisData.map(item => data[item] || 0);
    return {
      legend: {
        data: legendArr
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: xAxisData
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          name: legendArr[0],
          type: 'line',
          smooth: true,
          color: '#dc7272',
          data: getSeriesData(resouceArr[0])
        },
        {
          name: legendArr[1],
          type: 'line',
          smooth: true,
          color: '#5d93e4',
          data: getSeriesData(resouceArr[1])
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .page-title {
    padding: 8px 20px;
    border-bottom: 1px solid $border-light;
    margin: 0;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    font-size: 14px;
    color: #fff;
    background: $primary;
  }

  .section {
    @include shadow;
    margin-top: 20px;
  }

  .content {
    background: #fff;
  }

  .wrapper {
    .card {
      .page-title {
        text-align: center;
        font-weight: bold;
      }

      .content {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .item {
        flex: 1;
        height: 100%;
        text-align: center;

        [class^="el-icon-"] {
          font-size: 20px;
          margin-top: 10px;
        }

        .name {
          margin-top: 2px;
          font-weight: 500;
          color: #86888b;
        }

        .value {
          color: $price-color;
          margin: 10px 0 5px;
          font-size: 16px;
          font-weight: 800;
        }

      }
    }

    .special-card-wrapper {
      display: flex;
      margin-top: 15px;

      .card {
        flex: 1;
      }
    }
  }

  .box-order-data-overview {
    /deep/ .price-column {
      .cell {
        font-size: 14px;
        font-weight: 800;
        color: $price-color;
      }
    }

    /deep/ .field-column {
      .cell {
        padding: 0 20px;
        height: 26.1px;
      }
    }

    /deep/ .table-field-column {
      .cell {
        padding: 0px;
        margin: 0px;

        .el-button {
          text-align: left;
          text-indent: 20px;
          overflow: hidden;
          text-overflow: ellipsis;

          span {
            font-size: 14px;
            color: #86888b;
            white-space: nowrap;
          }
        }
      }
    }

    /deep/ .table-value-column {
      .cell {
        padding: 0;
        margin: 0;

        .el-button {
          text-align: left;

          span {
            font-size: 13px;
            font-weight: 800;
            color: #399e63;
          }
        }
      }
    }

    /deep/ .el-button {
      width: 100%;
    }
  }

  .box-charts {
    .content {
      display: flex;
      height: 400px;
      padding-top: 20px;

      .echarts {
        flex: 1;
      }
    }
  }

  .box-stat {
    height: 500px;

    .echarts {
      width: 100%;
    }
  }
</style>

